// Customizer const
export const TOGGLE_COLLAPSED_NAV = "toggle_collapse_menu";
export const DRAWER_TYPE = "drawer_type";
export const FIXED_DRAWER = "fixed_drawer";
export const COLLAPSED_DRAWER = "collapsible";
export const MINI_DRAWER = "mini_drawer";
export const THEME_COLOR = "theme_color";
export const DARK_THEME = "dark_theme";
export const WINDOW_WIDTH = "window-width";
export const SWITCH_LANGUAGE = "switch-language";
export const CHANGE_DIRECTION = "change-direction";

export const CHANGE_NAVIGATION_STYLE = "change-navigation-style";
export const HORIZONTAL_NAVIGATION = "horizontal_navigation";
export const VERTICAL_NAVIGATION = "vertical_navigation";

export const HORIZONTAL_MENU_POSITION = "horizontal_menu_position";
export const ABOVE_THE_HEADER = "above_the_header";
export const INSIDE_THE_HEADER = "inside_the_header";
export const BELOW_THE_HEADER = "below_the_header";

//Contact Module const

export const SHOW_MESSAGE = "show_message";
export const HIDE_MESSAGE = "hide_message";

export const FETCH_ALL_CONTACT = "fetch_all_contact";
export const FETCH_ALL_CONTACT_SUCCESS = "fetch_all_contact_success";
export const ADD_FAVOURITE = "add_favourite";
export const ON_HIDE_LOADER = "on_hide_loader";
export const ON_SHOW_LOADER = "on_show_loader";
export const ON_CONTACT_SELECT = "on_contact_select";
export const ON_ADD_CONTACT = "on_add_contact";
export const ON_CONTACT_CLOSE = "on_contact_close";
export const ON_FILTER_OPTION_SELECT = "on_filter_option_select";
export const ON_SAVE_CONTACT = "on_save_contact";
export const ON_DELETE_CONTACT = "on_delete_contact";
export const ON_DELETE_SELECTED_CONTACT = "on_delete_selected_contact";
export const FILTER_CONTACT = "filter_contact";
export const GET_ALL_CONTACT = "get_all_contact";
export const GET_UNSELECTED_ALL_CONTACT = "get_unselected_all_contact";
export const ON_ALL_CONTACT_SELECT = "on_all_contact_select";
export const UPDATE_SEARCH_USER = "update_search_user";
export const ON_TOGGLE_DRAWER = "on_toggle_drawer";
export const HANDLE_REQUEST_CLOSE = "handle_request_close";
export const HIDE_CONTACT_LOADER = "hide_contact_loader";

//Auth const
export const SIGNIN_USER = "signin_user";
export const SIGNIN_USER_SUCCESS = "signin_user_success";
export const SIGNIN_USER_FAILURE = "signin_user_failure";
export const SIGNIN_USER_FAILED = "signin_user_failed";
export const SIGNOUT_USER = "signout_user";
export const SIGNOUT_USER_SUCCESS = "signout_user_success";
export const SIGNOUT_USER_FAILED = "signout_user_failed";
export const INIT_URL = "init_url";
export const ADD_PATIENT = "add_patient";
export const ADD_PATIENT_SUCCESS = "add_patient_success";
export const ADD_PATIENT_FAILURE = "add_patient_failure";
export const VERIFY_OTP = "verify_otp";
export const VERIFY_OTP_SUCCESS = "verify_otp_success";
export const VERIFY_OTP_FAILED = "verify_otp_failed";
export const UPDATE_PATIENT = "update_patient";
export const UPDATE_PATIENT_SUCCESS = "update_patient_success";
export const UPDATE_PATIENT_FAILED = "update_patient_failed";
export const GET_PATIENT_INFO = "get_patient_info";

export const UPDATE_PATIENT_DETAILS = "update_patient_details";
export const UPDATE_PATIENT_DETAILS_SUCCESS = "update_patient_details_success";
export const UPDATE_PATIENT_DETAILS_FAILED = "update_patient_details_failed";

export const UPLOAD_PATIENT_REPORT = "upload_patient_report";
export const UPLOAD_PATIENT_REPORT_SUCCESS = "upload_patient_report_success";
export const UPLOAD_PATIENT_REPORT_FAILED = "upload_patient_report_failed";

export const TOGGLE_PATIENT_STATUS = "toggle_patient_status";
export const TOGGLE_PATIENT_STATUS_SUCCESS = "toggle_patient_status_success";
export const TOGGLE_PATIENT_STATUS_FAILED = "toggle_patient_status_failed";

export const DEVICE_OPERATION = "device_operation";
export const DEVICE_OPERATION_SUCCESS = "device_operation_success";
export const DEVICE_OPERATION_FAILED = "device_operation_failed";
export const RESET_DEVICE_OPERATION_RESPONSE =
  "reset_device_operation_response";

export const RESET_PATIENT_PASSWORD = "reset_patient_password";
export const RESET_PATIENT_PASSWORD_SUCCESS = "reset_patient_password_success";
export const RESET_PATIENT_PASSWORD_FAILED = "reset_patient_password_failed";
export const RESET_PATIENT_PASSWORD_STATE = "reset_patient_password_state";

export const DEPLOY_DEVICE_IN_PAST_DATE = "deploy_device_in_past_date";
export const DEPLOY_DEVICE_IN_PAST_DATE_SUCCESS =
  "deploy_device_in_past_date_success";
export const DEPLOY_DEVICE_IN_PAST_DATE_FAILED =
  "deploy_device_in_past_date_failed";
export const RESET_DEPLOY_DEVICE_IN_PAST_DATE = "reset_deploy_in_past_date";

export const FETCH_DEVICE_HISTORY = "fetch_device_history";
export const FETCH_DEVICE_HISTORY_SUCCESS = "fetch_device_history_success";
export const FETCH_DEVICE_HISTORY_FAILED = "fetch_device_history_failed";

export const FETCH_AVAILABLE_DEVICES_DATES = "fetch_available_devices_dates";
export const FETCH_AVAILABLE_DEVICES_DATES_SUCCESS =
  "fetch_available_devices_dates_success";
export const FETCH_AVAILABLE_DEVICES_DATES_FAILED =
  "fetch_available_devices_dates_failed";

export const FETCH_FUTURE_ALLOCATIONS = "fetch_future_allocations";
export const FETCH_FUTURE_ALLOCATIONS_SUCCESS =
  "fetch_future_allocations_success";
export const FETCH_FUTURE_ALLOCATIONS_FAILED =
  "fetch_future_allocations_failed";

export const CANCEL_FUTURE_ALLOCATIONS = "cancel_future_allocations";
export const CANCEL_FUTURE_ALLOCATIONS_SUCCESS =
  "cancel_future_allocations_success";
export const CANCEL_FUTURE_ALLOCATIONS_FAILED =
  "cancel_future_allocations_failed";

export const FETCH_LIVE_DEVICES = "fetch_live_devices";
export const FETCH_LIVE_DEVICES_SUCCESS = "fetch_live_devices_success";
export const FETCH_LIVE_DEVICES_FAILED = "fetch_live_devices_failed";

//Data center
export const FETCH_DATA_CENTER = "fetch_data_center";
export const FETCH_DATA_CENTER_SUCCESS = "fetch_data_center_success";
export const FETCH_DATA_SEARCH_QUERY = "fetch_data_search_query";
export const FETCH_DATA_SEARCH_QUERY_PAST = "fetch_data_search_query_past";

// Device Config
export const FETCH_DEVICE_CONFIG = "fetch_device_config";
export const FETCH_DEVICE_CONFIG_SUCCESS = "fetch_device_config_success";
export const FETCH_DEVICE_CONFIG_FAILURE = "fetch_device_config_failure";

export const UPDATE_DEVICE_CONFIG = "update_device_config";
export const UPDATE_DEVICE_CONFIG_SUCCESS = "update_device_config_success";
export const UPDATE_DEVICE_CONFIG_FAILURE = "update_device_config_failure";

// Forgot Password
export const FORGOT_PASSWORD = "forgot_password";
export const FORGOT_PASSWORD_SUCCESS = "forgot_password_success";
export const FORGOT_PASSWORD_FAILED = "forgot_password_failed";
export const FORGOT_PASSWORD_VERIFY_OTP = "forgot_password_verify_otp";
export const FORGOT_PASSWORD_VERIFY_OTP_SUCCESS =
  "forgot_password_verify_otp_success";
export const FORGOT_PASSWORD_VERIFY_OTP_FAILED =
  "forgot_password_verify_otp_failed";
export const RESET_PASSWORD = "reset_password";
export const RESET_PASSWORD_SUCCESS = "reset_password_success";
export const RESET_PASSWORD_FAILED = "reset_password_failed";

//widgets
export const FETCH_WIDGETS = "fetch_widgets";
export const FETCH_WIDGETS_SUCCESS = "fetch_widgets_success";
export const FETCH_WIDGETS_FAILED = "fetch_widgets_failed";

// No data

export const FETCH_PATIENT_WITH_NO_DATA = "fetch_data";
export const FETCH_PATIENT_WITH_NO_DATA_SUCCESS = "fetch_data_success";
export const FETCH_PATIENT_WITH_NO_DATA_FAILED = "fetch_data_failed";

//  Last night

export const FETCH_PATIENT_WITH_LAST_NIGHT_DATA =
  "fetch_patient_with_last_night_data";
export const FETCH_PATIENT_WITH_LAST_NIGHT_DATA_SUCCESS =
  "fetch_fpatient_with_last_night_data_success";
export const FETCH_PATIENT_WITH_LAST_NIGHT_DATA_FAILED =
  "fetch_patient_with_last_night_data_failed";

//  Recent Patient

export const FETCH_RECENT_PATIENT_DATA = "fetch_recent_patient_data";
export const FETCH_RECENT_PATIENT_DATA_SUCCESS =
  "fetch_recent_patient_data_success";
export const FETCH_RECENT_PATIENT_DATA_FAILED =
  "fetch_recent_patient_data_failed";

//update recent patient count
export const UPDATE_RECENT_PATIENT_COUNT = "update_recent_patient_count";
export const UPDATE_RECENT_PATIENT_COUNT_SUCCESS =
  "update_recent_patient_count_success";
export const UPDATE_RECENT_PATIENT_COUNT_FAILED =
  "update_recent_patient_count_failed";
//  Update User
export const UPDATE_USER_DETAILS = "update_user_details";
export const UPDATE_USER_DETAILS_SUCCESS = "update_user_details_success";
export const UPDATE_USER_DETAILS_FAILED = "update_user_details_failed";
export const RESET_UPDATE_USER_DETAILS = "reset_update_user_details";
//  Add patient comment
export const SAVE_PATIENT_COMMENT = "save_patient_comment";
export const SAVE_PATIENT_COMMENT_SUCCESS = "save_patient_comment_success";
export const SAVE_PATIENT_COMMENT_FAILED = "save_patient_comment_failed";
// fetch patient comment
export const FETCH_PATIENT_COMMENT = "fetch_patient_comment";
export const FETCH_PATIENT_COMMENT_SUCCESS = "fetch_patient_comment_success";
export const FETCH_PATIENT_COMMENT_FAILED = "fetch_patient_comment_failed";

export const UPDATE_PATIENT_COMMENT = "update_patient_comment";
export const UPDATE_PATIENT_COMMENT_SUCCESS = "update_patient_comment_success";
export const UPDATE_PATIENT_COMMENT_FAILED = "update_patient_comment_failed";

export const DELETE_PATIENT_COMMENT = "delete_patient_comment";
export const DELETE_PATIENT_COMMENT_SUCCESS = "delete_patient_comment_success";
export const DELETE_PATIENT_COMMENT_FAILED = "delete_patient_comment_failed";

// fetch disease list
export const FETCH_DISEASE_LIST = "fetch_disease_list";
export const FETCH_DISEASE_LIST_SUCCESS = "fetch_disease_list_success";
export const FETCH_DISEASE_LIST_FAILED = "fetch_disease_list_failed";

export const FETCH_PATIENTS_SUMMARY = "fetch_patients_summary";
export const FETCH_PATIENTS_SUMMARY_SUCCESS = "fetch_patients_summary_success";
export const FETCH_PATIENTS_SUMMARY_FAILED = "fetch_patients_summary_failed";

export const FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY =
  "fetch_patient_medication_symptoms_history";
export const FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_SUCCESS =
  "fetch_patient_medication_symptoms_history_success";
export const FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_FAILED =
  "fetch_patient_medication_symptoms_history_failed";

export const FETCH_PATIENTS_RII_SUMMARY = "fetch_patients_rii_summary";
export const FETCH_PATIENTS_RII_SUMMARY_SUCCESS =
  "fetch_patients_rii_summary_success";
export const FETCH_PATIENTS_RII_SUMMARY_FAILED =
  "fetch_patients_rii_summary_failed";

export const FETCH_PATIENT_DISEASE = "fetch_patient_disease";
export const FETCH_PATIENT_DISEASE_SUCCESS = "fetch_patient_disease_success";
export const FETCH_PATIENT_DISEASE_FAILED = "fetch_patient_disease_failed";

// Patient Check up
export const FETCH_CHECKUP_DATES = "fetch_checkup_dates";
export const FETCH_CHECKUP_DATES_SUCCESS = "fetch_checkup_dates_success";
export const FETCH_CHECKUP_DATES_FAILED = "fetch_checkup_dates_failed";

// add checkup date
export const ADD_CHECKUP_DATE = "add_checkup_date";
export const ADD_CHECKUP_DATE_SUCCESS = "add_checkup_date_success";
export const ADD_CHECKUP_DATE_FAILED = "add_checkup_date_failed";

//add checkup mark as complete
export const CHECKUP_MARK_AS_COMPLETE = "checkup_mark_as_complete";
export const CHECKUP_MARK_AS_COMPLETE_SUCCESS =
  "checkup_mark_as_complete_success";
export const CHECKUP_MARK_AS_COMPLETE_FAILED =
  "checkup_mark_as_complete_failed";
// no check for long time
export const NO_CHECK_FOR_LONG = "no_check_for_long";
export const FETCH_NO_CHECK_FOR_LONG_SUCCESS = "no_check_for_long_success";
export const FETCH_NO_CHECK_FOR_LONG_FAILED = "no_check_for_long_failed";

// Get Countries
export const GET_LIST_OF_COUNTRIES = "get_list_of_countries";
export const GET_LIST_OF_COUNTRIES_SUCCESS = "get_list_of_countries_success";
export const GET_LIST_OF_COUNTRIES_FAILED = "get_list_of_countries_failed";

export const FETCH_AVAILABLE_DEVICES = "fetch_available_devices";
export const FETCH_AVAILABLE_DEVICES_SUCCESS =
  "fetch_available_devices_success";
export const FETCH_AVAILABLE_DEVICES_FAILED = "fetch_available_devices_success";

// Live Device Module const
export const REALTIME_CONNECTION = "realtime_connection";
export const REALTIME_CONNECTION_CONNECTED = "realtime_connection_connected";
export const REALTIME_CONNECTION_DISCONNECTED =
  "realtime_connection_disconnected";
export const REALTIME_CONNECTION_AUTHENTICATING =
  "realtime_connection_authenticating";
export const REALTIME_CONNECTION_AUTHENTICATED =
  "realtime_connection_authenticated";

export const VALIDATE_REAL_TIME_REQUEST_PARAMS =
  "validate_real_time_request_params";
export const VALIDATE_REAL_TIME_REQUEST_PARAMS_SUCCESS =
  "validate_real_time_request_params_success";
export const VALIDATE_REAL_TIME_REQUEST_PARAMS_FAILED =
  "validate_real_time_request_params_failed";

export const GET_REAL_TIME_DATA = "get_real_time_data";
export const GET_REAL_TIME_DATA_SUCCESS = "get_real_time_data_success";
export const GET_REAL_TIME_DATA_FAILED = "get_real_time_data_failed";

//// Mail Module const

export const ADD_LABEL = "ADD_LABEL";
export const FETCH_USER_DETAILS = "get_user_details";
export const FETCH_USER_DETAILS_SUCCESS = "get_user_details_success";
export const FETCH_USER_DETAILS_FAILED = "get_user_details_failed";

export const FETCH_PATIENTS = "fetch_patients";
export const FETCH_PATIENTS_SUCCESS = "fetch_patients_success";
export const FETCH_PATIENTS_FAILED = "fetch_patients_failed";

export const FETCH_PATIENTS_QNA = "fetch_patients_qna";
export const FETCH_PATIENTS_QNA_SUCCESS = "fetch_patients_qna_success";
export const FETCH_PATIENTS_QNA_FAILED = "fetch_patients_qna_failed";

export const FETCH_DEVICES_LIST = "fetch_devices_list";
export const FETCH_DEVICES_LIST_SUCCESS = "fetch_devices_list_success";
export const FETCH_DEVICES_LIST_FAILED = "fetch_devices_list_failed";

export const SET_PATIENT_INFO_NULL = "SET_PATIENT_INFO_NULL";
export const FETCH_PATIENT_DATA_LOADING = "FETCH_PATIENT_DATA_LOADING";
export const FETCH_PATIENT_DATA = "fetch_patient_data";
export const FETCH_PATIENT_DATA_SUCCESS = "fetch_patient_data_success";
export const FETCH_PATIENT_DATA_FAILED = "fetch_patient_data_failed";

export const FETCH_AVAILABLE_KPIS = "fetch_available_kpis";
export const FETCH_AVAILABLE_KPIS_SUCCESS = "fetch_available_kpis_success";
export const FETCH_AVAILABLE_KPIS_FAILED = "fetch_available_kpis_failed";

export const FETCH_KPI_DATA = "fetch_kpi_data";
export const FETCH_KPI_DATA_SUCCESS = "fetch_kpi_data_success";
export const FETCH_KPI_DATA_FAILED = "fetch_kpi_data_failed";

export const FETCH_S3_KPI_DATA = "fetch_s3_kpi_data";
export const FETCH_S3_KPI_DATA_SUCCESS = "fetch_s3_kpi_data_success";
export const FETCH_S3_KPI_DATA_FAILED = "fetch_s3_kpi_data_failed";

export const FETCH_TV_KPI_DATA = "fetch_tv_kpi_data";
export const FETCH_TV_KPI_DATA_SUCCESS = "fetch_tv_kpi_data_success";
export const FETCH_TV_KPI_DATA_FAILED = "fetch_tv_kpi_data_failed";
export const RESET_TV_KPI_DATA = "reset_tv_kpi_data";

export const GENERATE_PHYSICIAN_NOTIFICATIONS =
  "generate_physician_notifications";
export const GENERATE_PHYSICIAN_NOTIFICATIONS_SUCCESS =
  "generate_physician_notifications_success";
export const GENERATE_PHYSICIAN_NOTIFICATIONS_FAILED =
  "generate_physician_notifications_failed";

export const FETCH_PHYSICIAN_NOTIFICATIONS = "fetch_physician_notifications";
export const FETCH_PHYSICIAN_NOTIFICATIONS_SUCCESS =
  "fetch_physician_notifications_success";
export const FETCH_PHYSICIAN_NOTIFICATIONS_FAILED =
  "fetch_physician_notifications_failed";

export const UPDATE_PHYSICIAN_NOTIFICATION = "update_physician_notification";
export const UPDATE_PHYSICIAN_NOTIFICATION_SUCCESS =
  "update_physician_notification_success";
export const UPDATE_PHYSICIAN_NOTIFICATION_FAILED =
  "update_physician_notification_failed";

export const FETCH_DEALLOCATION_NOTIFICATIONS =
  "fetch_deallocation_notifications";
export const FETCH_DEALLOCATION_NOTIFICATIONS_SUCCESS =
  "fetch_deallocation_notifications_success";
export const FETCH_DEALLOCATION_NOTIFICATIONS_FAILED =
  "fetch_deallocation_notifications_failed";

export const GENERATE_SYSTEM_ANNOTATIONS = "generate_system_annotations";
export const GENERATE_SYSTEM_ANNOTATIONS_SUCCESS =
  "generate_system_annotations_success";
export const GENERATE_SYSTEM_ANNOTATIONS_FAILED =
  "generate_system_annotations_failed";

export const FETCH_ANNOTATIONS = "fetch_annotations";
export const FETCH_ANNOTATIONS_SUCCESS = "fetch_annotations_success";
export const FETCH_ANNOTATIONS_FAILED = "fetch_annotations_failed";

export const DELETE_ANNOTATIONS = "delete_annotations";

export const ADD_NEW_ANNOTATION = "add_new_annotation";
export const ADD_NEW_ANNOTATION_SUCCESS = "add_new_annotation_success";
export const ADD_NEW_ANNOTATION_FAILED = "add_new_annotation_failed";

export const EDIT_ANNOTATION = "edit_annotation";
export const EDIT_ANNOTATION_SUCCESS = "edit_annotation_success";
export const EDIT_ANNOTATION_FAILED = "edit_annotation_failed";

export const FETCH_ANNOTATION_CATEGORIES = "fetch_annotation_categories";
export const FETCH_ANNOTATION_CATEGORIES_SUCCESS =
  "fetch_annotation_categories_success";
export const FETCH_ANNOTATION_CATEGORIES_FAILED =
  "fetch_annotation_categories_failed";

export const ADD_ANNOTATION_CATEGORY = "add_annotation_category";
export const ADD_ANNOTATION_CATEGORY_SUCCESS =
  "add_annotation_category_success";
export const ADD_ANNOTATION_CATEGORY_FAILED = "add_annotation_category_failed";

export const EDIT_ANNOTATION_CATEGORY = "edit_annotation_category";
export const EDIT_ANNOTATION_CATEGORY_SUCCESS =
  "edit_annotation_category_success";
export const EDIT_ANNOTATION_CATEGORY_FAILED =
  "edit_annotation_category_failed";

export const DELETE_ANNOTATION_CATEGORY = "delete_annotation_category";
export const DELETE_ANNOTATION_CATEGORY_SUCCESS =
  "delete_annotation_category_success";
export const DELETE_ANNOTATION_CATEGORY_FAILED =
  "delete_annotation_category_failed";

export const FETCH_GRAPH_DATA = "fetch_graph_data";
export const FETCH_GRAPH_DATA_SUCCESS = "fetch_graph_data_success";
export const FETCH_GRAPH_DATA_FAILED = "fetch_graph_data_failed";

export const FETCH_NIGHTS_AVAILABLE = "fetch_nights_available";
export const FETCH_NIGHTS_AVAILABLE_SUCCESS = "fetch_nights_available_success";
export const FETCH_NIGHTS_AVAILABLE_FAILED = "fetch_nights_available_failed";

export const FETCH_ACTIGRAPH = "fetch_actigraph";
export const FETCH_ACTIGRAPH_SUCCESS = "fetch_actigraph_success";
export const FETCH_ACTIGRAPH_FAILED = "fetch_actigraph_failed";

export const GET_KPI_SUMMARY = "socket/get_kpi_summary";
export const GET_KPI_SUMMARY_SUCCESS = "socket/get_kpi_summary_success";
export const GET_KPI_SUMMARY_FAILED = "socket/get_kpi_summary_failed";

export const GET_ML_KPI_SUMMARY = "socket/get_ml_kpi_summary";
export const GET_ML_KPI_SUMMARY_SUCCESS = "socket/get_ml_kpi_summary_success";
export const GET_ML_KPI_SUMMARY_FAILED = "socket/get_ml_kpi_summary_failed";

export const FETCH_ALL_MAIL = "fetch_all_mail";
export const FETCH_ALL_MAIL_SUCCESS = "fetch_all_mail_success";

export const GENERATE_PATIENT_ID = "generate_patient_id";
export const GENERATE_PATIENT_ID_SUCCESS = "generate_patient_id_success";
export const GENERATE_PATIENT_ID_FAILED = "generate_patient_id_failed";

export const ADD_NEW_PATIENT = "add_new_patient";
export const ADD_NEW_PATIENT_SUCCESS = "add_new_patient_success";
export const ADD_NEW_PATIENT_FAILED = "add_new_patient_failed";
export const RESET_NEW_PATIENT_RESPONSE = "reset_new_patient_response";

export const RESET_NEW_PATIENT_VALIDATION = "RESET_NEW_PATIENT_VALIDATION";

export const FETCH_USER_COUNTRIES = "fetch_user_countries";
export const FETCH_USER_COUNTRIES_SUCCESS = "fetch_user_countries_success";
export const FETCH_USER_COUNTRIES_FAILED = "fetch_user_countries_failed";

//all specialization list
export const GET_LIST_OF_SPECIALISATION = "get_list_of_specialisation";
export const GET_LIST_OF_SPECIALISATION_SUCCESS =
  "get_list_of_specialisation_success";
export const GET_LIST_OF_SPECIALISATION_FAILED = "get_list_of_countries_failed";

export const VIEW_PROFILE = "view_profile";

export const UPDATE_KPI_PREFERENCE = "update_kpi_preference";
export const UPDATE_KPI_PREFERENCE_SUCCESS = "update_kpi_preference_success";
export const UPDATE_KPI_PREFERENCE_FAILED = "update_kpi_preference_failed";
export const UPDATE_TRENDVIEW_KPI_PREFERENCE =
  "update_trendview_kpi_preference";
export const UPDATE_TRENDVIEW_KPI_PREFERENCE_SUCCESS =
  "update_trendview_kpi_preference_success";
export const UPDATE_TRENDVIEW_KPI_PREFERENCE_FAILED =
  "update_trendview_kpi_preference_failed";

export const FETCH_PATIENT_JIRA_CARDS_DATA = "fetch_patient_jira_cards_data";
export const FETCH_PATIENT_JIRA_CARDS_DATA_SUCCESS =
  "fetch_patient_jira_cards_data_success";
export const FETCH_PATIENT_JIRA_CARDS_DATA_FAILED =
  "fetch_patient_jira_cards_data_failed";

export const CANCEL_FORGOT_PASSWORD = "CANCEL_FORGOT_PASSWORD";
export const RESET_AUTH_INFO = "RESET_AUTH_INFO";

// FOR REALTIME NOTIFICATIONS
export const ALERT_MSG = "alert_msg";

//For Editing Report
export const EDIT_REPORT_VALUES = "edit_report_values";

export const RESET_REPORT_ERROR = "RESET_REPORT_ERROR";

//Update Sample Patient

export const UPDATE_SAMPLE_PATIENT = "update_sample_patient";
export const UPDATE_SAMPLE_PATIENT_SUCCESS = "update_sample_patient_success";
export const UPDATE_SAMPLE_PATIENT_FAILED = "update_sample_patient_failed";

export const REFRESH_STATISTICS = "refresh_statistics";

export const GENERATE_AUTOMATED_REPORT_DATA = "generate_automated_report_data";
export const GENERATE_AUTOMATED_REPORT_STATUS =
  "generate_automated_report_status";
export const GENERATE_AUTOMATED_REPORT = "generate_automated_report";

export const GENERATE_REPORT_SUCCESS = "generate_report_success";
export const GENERATE_REPORT_FAILED = "generate_report_failed";
